import { type AxiosResponse } from 'axios'
import api from '../utils/api'

export const getLookUpQuestion = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/items/', { params })
}
export default {
  getLookUpQuestion
}
